import React from 'react';

const ThreeDsChallengeModal: React.FC<React.PropsWithChildren<{
  acsUrl: string;
  challengeRequestToken: string;
  onChallengeSuccess: (creq: string) => void;
  headerIdMessage: string;
}>> = () => {
  return null;
};

export default ThreeDsChallengeModal;
